define('gigaset_csp/components/support/detail/faq/categories',[
	"jquery",
	"lodash",
	"cartware/components/_base",
	"cartware/jquery/bem"
], function(
	$,
	_,
	Component,
	BEM
) {
	var BLOCK = "csp-support-detail-faq-categorized";
	var ELEMENT_LIST_ITEM_CLASS = '.' + BEM.buildElementClassname(BLOCK, 'list-item');
	var ELEMENT_CATEGORY_TITLE_CLASS = '.' + BEM.buildElementClassname(BLOCK, 'category-title');
	var ELEMENT_ENTRY_LIST_CLASS = '.' + BEM.buildElementClassname(BLOCK, 'entry-list');

	return Component.create({
		block: null,
		product: null,

		$init: function() {
			this.block = BEM.block(BLOCK);

			this.bindEvents();
		},

		bindEvents: function() {
			this.block.on(
				"click", ELEMENT_CATEGORY_TITLE_CLASS, function(e) {
					var title = $(this),
						listItem = title.closest(ELEMENT_LIST_ITEM_CLASS),
						entryList = listItem.find(ELEMENT_ENTRY_LIST_CLASS);

					entryList.slideToggle();
				}
			);
		},

		registerFaqView: function (faqUrl) {
			PubSubHub.emit("csp.support.detail.faq.view", {
				faqUrl: faqUrl,
				product: this.product.name
			});
		}
	});
});
